module.exports = __webpack_public_path__ + "static/img/contact_logo5.4bd4440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo5.png
// module id = CvzB
// module chunks = 1